module.exports = __webpack_public_path__ + "static/media/img-card-six.e3d63af1.jpg";